export default "__VITE_ASSET__CQc3Pre9__"